import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import "verte/dist/verte.css"
import VueResource from 'vue-resource';

Vue.use(VueResource);

Vue.http.interceptors.push(function(request) {
  store.commit('setShowLoader', { newResult: true });
  return function(response) {
      store.commit('setShowLoader', { newResult: false });
  }
});

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
